import React from 'react';
import Tabs from '../../../Tabs/Tabs';
import LabelTab from './LabelTab';
import { SearchStateProps } from '../EventCards/EventCardList';
import { EventSeriesWithNextOccurrence } from 'Services/Api/_HumanWritten/EventSeriesEntityService';
import { EventLabelEntity } from 'Models/Entities';

export interface EventTabsProps {
	allExperiences: EventSeriesWithNextOccurrence[];
	setAllExperiences: React.Dispatch<React.SetStateAction<EventSeriesWithNextOccurrence[]>>;
	labels: EventLabelEntity[];
	searchState: SearchStateProps | null;
	loading: boolean;
}

export const EventTabs = ({ allExperiences, setAllExperiences, labels, searchState, loading }: EventTabsProps) => {
	// If only one label (or zero), don't show tabs -- just show a flat list
	if (labels.length <= 1) {
		return (
			<>
				<h3 className="events-list__header">What&apos;s on</h3>
				<LabelTab
					labelId={undefined}
					experiencesList={allExperiences}
					setExperiencesList={setAllExperiences}
					searchState={searchState}
					initialLoading={loading}
				/>
			</>
		);
	}

	// Build tabs: "All experiences" first, then one tab per label
	const tabs = [
		{
			name: 'All experiences',
			key: 'all-experiences',
			component: (
				<LabelTab
					key="all-experiences"
					labelId={undefined}
					experiencesList={allExperiences}
					setExperiencesList={setAllExperiences}
					searchState={searchState}
					initialLoading={loading}
				/>
			),
		},
		...labels.map(label => ({
			name: label.label,
			key: `label-${label.id}`,
			component: (
				<LabelTab
					key={`label-${label.id}`}
					labelId={label.id}
					initialItems={allExperiences.filter(e => e.eventLabelId === label.id)}
					searchState={searchState}
					initialLoading={loading}
				/>
			),
		})),
	];

	return (
		<>
			<h3 className="events-list__header">What&apos;s on</h3>
			<Tabs className="events-list__tabs" tabs={tabs} />
		</>
	);
};

export const calculateNumberOfFeaturedEvents = (windowWidth: number = window.innerWidth) => {
	return Math.max(Math.ceil(windowWidth / 300), 5);
};
